export type TipoPessoaCliente = 'PF' | 'PJ';

export type TipoClienteVendepay = 'SEMENTE' | 'FRUTO';

export enum StatusKycCliente {
  NAO_INICIADO = 1,
  PENDENTE = 2,
  APROVADO = 3,
  REPROVADO = 4,
}

export const STATUS_KYC_LABEL: Record<StatusKycCliente, string> = {
  [StatusKycCliente.NAO_INICIADO]: 'Não iniciado',
  [StatusKycCliente.PENDENTE]: 'Pendente',
  [StatusKycCliente.APROVADO]: 'Aprovado',
  [StatusKycCliente.REPROVADO]: 'Reprovado',
};

export interface ClienteListItem {
  id: string;
  nome: string;
  sobrenome: string | null;
  email: string;
  tipoPessoa: TipoPessoaCliente | null;
  documento: string | null;
  telefone: string | null;
  statusKyc: StatusKycCliente | null;
  statusKycDescricao: string | null;
  isSaleBlocked: boolean;
  isPayoutBlocked: boolean;
  identidadeVerificada: boolean;
}

export interface PaginatedClientes {
  data: ClienteListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ClienteEndereco {
  cep: string | null;
  estado: string | null;
  cidade: string | null;
  bairro: string | null;
  logradouro: string | null;
  numero: string | null;
  complemento: string | null;
}

export interface ClienteDetail extends ClienteListItem {
  tipoCliente: TipoClienteVendepay | null;
  cpf: string | null;
  cnpj: string | null;
  razaoSocial: string | null;
  nomeFantasia: string | null;
  dataNascimento: string | null;
  celular1: string | null;
  celular2: string | null;
  celular3: string | null;
  instagram: string | null;
  facebook: string | null;
  endereco: ClienteEndereco;
  documentosAprovados: boolean;
  tempoRecebimento: number | null;
  tempoRecebimentoDescricao: string | null;
  isD3Enabled: boolean;
  comoUsar: number | null;
  comoUsarDescricao: string | null;
  faturamentoMedio: number | null;
  onboardingRealizado: boolean;
}

export interface ClientesFilters {
  search?: string;
  documento?: string;
  tipoPessoa?: TipoPessoaCliente | '';
  statusKyc?: StatusKycCliente | '';
}

export type ClientesFiltersInput = Partial<ClientesFilters>;

export interface ManualKycApprovalResponse {
  historyId: string;
  clienteId: string;
  statusKyc: StatusKycCliente.APROVADO;
  approvedAt: string;
}
